module.exports = __webpack_public_path__ + "img/Subtract@2x(2).07c83fa1.png";